<template>
    <div>
        <b-form-group class="questions">
            <div v-for="(item, index) in form" :key="index">
                <label>
                    {{ item.question.text }}
                </label>

                <b-input-group>
                    <b-form-input
                        class="tb-form-field tb-form-field--with-side-by-side tb-form-field--black"
                        type="text"
                        v-model="item.answer.text"
                        @input="answerChanged(index, item.answer.text)"
                        placeholder="Your answer">    
                    </b-form-input>

                    <b-input-group-append>
                        <b-button
                            class="tb-form-field__side-by-side"
                            @click.prevent="item.answer.text = ''; answerChanged(index, '')">
                            Clear
                        </b-button>
                    </b-input-group-append>
                </b-input-group>
            </div>
        </b-form-group>
    </div>
</template>

<script>
    export default {
        props: {
            questions: {
                required: true
            },

            answers: {}
        },

        data() {
            return {
                form: []
            }
        },

        mounted() {
            this.setForm();
        },

        methods: {
            answerChanged(index, text) {
                this.$emit('changed', index, text);
            },

            setForm() {
                this.form = this.questions.map((question) => {
                    return {
                        question: question,
                        answer: this.answers.find((answer) => {
                            return answer.question_id == question.id
                        }) || {
                            text: ""
                        }
                    }
                });
            },
        },
    }
</script>

<style scoped lang="scss">
    .questions {
        margin-top: 0!important;

        .input-group {
            margin-bottom: 10px;
        }

        input {
            margin-bottom: 0!important;
        }
    }

    .answerable-question-list--white {
        .tb-form-field {
            border-color: $color-white!important;
            border-right: none;
            color: $color-white!important;
        }
    }
</style>